import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';

import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';


import PieChartIcon from '@mui/icons-material/PieChart';
import TypesIndicateursAncienneteGraph from './TypesIndicateursAncienneteGraph';
import TypesIndicateursNbOuvertesGraph from './TypesIndicateursNbOuvertesGraph';
import withLoader from 'components/Shared/withLoader';

const styles = {
    graph: {
        width: '50%',
        display: 'inline-block'
    }
};

const TypesIndicateursAncienneteGraphWithLoader = withLoader(TypesIndicateursAncienneteGraph);
const TypesIndicateursNbOuvertesGraphWithLoader = withLoader(TypesIndicateursNbOuvertesGraph);

const TypesIndicateurs = ({ classes, isLoading, groupes, selectedGroupeIndexes, onGroupeChange }) => {
    
    let indicateurs = !groupes || !groupes[0] || (selectedGroupeIndexes.length === 0) ? [] :
        JSON.parse(JSON.stringify(groupes[selectedGroupeIndexes[0]].indicateurs)); // On force la copie


    if (selectedGroupeIndexes.length > 1) {

        for (let i = 1; i < selectedGroupeIndexes.length; i++) {

            for (let j = 0; j < groupes[selectedGroupeIndexes[i]].indicateurs.length; j++) {

                let indicateur = groupes[selectedGroupeIndexes[i]].indicateurs[j];

                let k = indicateurs.findIndex(x => x.libelle === indicateur.libelle);

                if (k !== -1) {
                    indicateurs[k].ancienneteMoyenne = Math.floor((indicateurs[k].nombre * indicateurs[k].ancienneteMoyenne + indicateur.nombre * indicateur.ancienneteMoyenne) / (indicateurs[k].nombre + indicateur.nombre))
                    indicateurs[k].nombre += indicateur.nombre;
                }
                else {
                    indicateurs.push(JSON.parse(JSON.stringify(indicateur)));
                }

            }
            

        }
    }

    return (
        <Card>
            <CardHeader title="Types de dossier après-vente" avatar={<Avatar><PieChartIcon /></Avatar>}

                subheader={groupes && groupes[0] && (

                    groupes.length === 1 ?
                        <p>{groupes[0].libelle}</p> :

                        <TextField
                            sx={{ marginTop: '16px' }}
                            id={"groupe"}
                            name={"groupe"}
                            label={"Groupe(s) de traitement"}
                            fullWidth

                            select
                            SelectProps={{
                                multiple: true,
                                value: selectedGroupeIndexes,
                                onChange: onGroupeChange,
                                renderValue: (values) => {
                                    return (<div>{values.map(x => groupes[x].libelle).join(', ')}</div>);
                                }
                            }}
                            >
                            
                            <MenuItem value="" disabled>Sélectionner un ou plusieurs groupes</MenuItem>

                            {groupes.map((groupe, index) => (
                                <MenuItem key={index} value={index}>

                                    <Checkbox checked={selectedGroupeIndexes.indexOf(index) > -1} />
                                    <ListItemText primary={groupe.libelle} />
                                </MenuItem>
                            ))}
                        </TextField>

                )}

            />


            <CardContent>
                <div className={classes.graph}>
                    <TypesIndicateursAncienneteGraphWithLoader isLoading={isLoading} indicateurs={indicateurs} />
                </div>
                <div className={classes.graph}>
                    <TypesIndicateursNbOuvertesGraphWithLoader isLoading={isLoading} indicateurs={indicateurs} />
                </div>
            </CardContent>
        </Card>
    )
};

TypesIndicateurs.propTypes = {
    classes: PropTypes.object.isRequired,
    groupes: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    selectedGroupeIndexes: PropTypes.array.isRequired
};

export default withStyles(styles)(TypesIndicateurs);